import { FC, Fragment, useRef, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormHelperText,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  ImageListItem,
  ImageListItemBar,
  Card,
  TextField,
  FormControl,
  InputLabel,
  styled
} from '@mui/material';
import PropTypes from 'prop-types';
import request from 'src/utils/request';
import Document from '../common/document.jpg';
import { DatePicker, LoadingButton, LocalizationProvider } from '@mui/lab';
import Dropzone from 'react-dropzone';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import moment from 'moment';
import FileSizeWarningModal from './FileSizeWarningModal';
import PolicyAttachments from './PolicyAttachments';

type AddPolicyViewProps = {
  addPolicyModal: any;
  policyId?: any;
  setAddPolicyModal: Function;
  setShowSnackBarAlert: Function;
  placementSlipDetail: Function;
  reissue: boolean;
  type?: any;
  fetchPolicyList?: Function;
};
const AddPolicyView: FC<AddPolicyViewProps> = ({
  addPolicyModal,
  setAddPolicyModal,
  placementSlipDetail,
  setShowSnackBarAlert,
  reissue,
  policyId,
  type = null,
  fetchPolicyList
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [flag, setFlag] = useState<boolean>(false);
  const [hasBeenClicked, setHasBeenClicked] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loader, setLoader] = useState<boolean>(false);
  const [openWarning, setOpenWarning] = useState<{
    status: boolean;
    type: string;
  }>({ status: false, type: null });

  const ErrorMessage = styled(Box)(
    () => `
          color: #FF1943;
          font-weight: bold;
          font-size: 13px;
          margin-left: 8px;
          margin-top: 20px;
      `
  );

  const SUPPORTED_FORMATS = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'application/pdf',
    '.png',
    '.jpeg',
    '.jpg',
    '.docx',
    '.csv',
    '.xlsx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
  ];

  const SUPPORTED_DOCUMENTFORMATS = ['application/pdf'];

  const PolicySlipSchema = Yup.object().shape({
    policyFile: Yup.array()
      .nullable()
      .notRequired()
      .test(
        'FILE_SIZE',
        'The uploaded file(s) exceed(s) the size limit',
        (value) => {
          if (!value) return true;
          const totalSize = value.reduce((acc, file) => acc + file.size, 0);
          return totalSize <= 5242880;
        }
      )
      .test(
        'FILE_FORMAT',
        'One or more uploaded files have unsupported format',
        (values) => {
          if (!values) return true;
          return values.every((file) => SUPPORTED_FORMATS.includes(file.type));
        }
      ),
    policyIssueDate: Yup.string()
      .required('Policy Issue Date is required')
      .nullable(),
    policyDocumentReceivedDate: Yup.string()
      .required('Policy Document Received Date is required')
      .nullable(),
    policyNumber: Yup.string()
      .required('Policy Number is required')
      .min(3, 'Policy Number must be at least 3 characters long')
      .trim('Policy Number cannot include leading and trailing spaces')
      .strict()
      // .matches(
      //   /^[a-zA-Z0-9\s]+$/,
      //   'Policy Number cannot contain special characters'
      // )
      .nullable(),

    policyDocument: Yup.mixed()

      .required('Policy Document is required')
      .test('is-file-of-correct-type', 'Unsupported file format', () => {
        let valid = true;
        const files = fileRef?.current?.files;
        if (files) {
          const fileArr = Array.from(files);
          fileArr.forEach((file: any) => {
            const type = file.type.split('/')[1];
            console.log(type);
            const validTypes = ['pdf'];
            if (!validTypes.includes(type)) {
              valid = false;
            }
            console.log(valid);
          });
        }
        return valid;
      })

      .test(
        'FILE_SIZE',
        'Uploaded file is too big. Max size is 5MB',
        (values) => {
          let valid = true;
          if (values?.size) {
            if (values && values.size <= 5000000) {
              valid = true;
            } else {
              valid = false;
            }
          }

          return valid;
        }
      )
  });
  console.log('addPolicyModal:::', addPolicyModal);
  const [supportingPolicyDocument, SetSupportingPolicyDocument] =
    useState('.pdf');
  const fileRef = useRef(null);
  const [retImage, setRetImage] = useState(null);
  const [error, setError] = useState('');

  const policyForm = useFormik({
    initialValues: {
      // policyNumber: addPolicyModal?.addDetail?.rfq?.renewalNumber ?? null, as per client no need to auto populate policy number
      policyNumber: null,
      policyIssueDate: null,
      policyDocumentReceivedDate: null,
      policyFile: [],
      insuranceCompany: addPolicyModal?.addDetail?.rfqOffer?.inscompany?.name
        ? addPolicyModal?.addDetail?.rfqOffer?.inscompany?.name
          ?.charAt(0)
          .toUpperCase() +
        addPolicyModal?.addDetail?.rfqOffer?.inscompany?.name?.slice(1)
        : addPolicyModal?.insuranceCompany ? addPolicyModal?.insuranceCompany?.name : 'N/A',
      policyDocument: null,
      documentDetails: [],
    },
    validationSchema: PolicySlipSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      const formData = new FormData();
      setLoader(true);
      formData.append('policyNumber', values.policyNumber);
      if (addPolicyModal?.addDetail?.rfq?.rfqType === 'Renewal') {
        formData.append(
          'policyRenewalCount',
          addPolicyModal?.addDetail?.rfq?.renewalNumber?.split('/')?.pop()
        );
      }
      formData.append('placementId', addPolicyModal?.addDetail?.id);
      formData.append('policyIssueDate', values.policyIssueDate);
      formData.append('policyDocument', retImage);

      formData.append(
        'policyDocumentReceivedDate',
        values.policyDocumentReceivedDate
      );
      values?.policyFile?.forEach((acceptedFile) => {
        formData.append('files', acceptedFile);
      });
      const formattedDocumentDetails =
        values.documentDetails.map((name) => ({
          name
        }));
      formData.append(
        'documentDetails',
        JSON.stringify(formattedDocumentDetails)
      );
      if (reissue === true) {
        formData.append('policyId', policyId);
      }
      await request;
      if (reissue === true) {
        let URL = 'insurancePolicy/policyReissue'
        if (type == 'cancelAndReissue') {
          URL = '/insurancePolicy/cancelAndReissue'
          formData.append('newPolicyNumber', values.policyNumber)
        }
        request({
          url: URL,
          method: 'POST',
          data: formData
        })
          .then((response) => {
            if (response.status) {
              setLoader(false);
              setShowSnackBarAlert({
                status: true,
                type: 'success',
                message: response['message']
              });
              setIsLoading(false);
              if (type !== 'cancelAndReissue') {
                // window.location.href = `/dashboards/policies?policy_Id=${response?.data?.id
                //   }&parent_policy_id=${addPolicyModal?.addDetail?.rfq?.parentPolicyId ?? null
                //   }`;
                fetchPolicyList();

              } else {
                fetchPolicyList();
                setAddPolicyModal({
                  addDetail: null,
                  policyId: null,
                  status: false
                });
              }

            } else {
              setLoader(false);
              setShowSnackBarAlert({
                status: true,
                type: 'error',
                message: response['message']
              });
              policyForm.setErrors({});
              setIsLoading(false);
            }
          })
          .catch(function (err) {
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: err.message
            });
            setLoader(false);
            setIsLoading(false);
          });
      } else {
        request({
          url: 'insurancePolicy/create',
          method: 'POST',
          data: formData
        })
          .then((response) => {
            if (response.status) {
              setLoader(false);
              setShowSnackBarAlert({
                status: true,
                type: 'success',
                message: response['message']
              });
              setIsLoading(false);
              window.location.href = `/dashboards/policies?policy_Id=${response?.data?.id
                }&parent_policy_id=${addPolicyModal?.addDetail?.rfq?.parentPolicyId ?? null
                }`;
            } else {
              setLoader(false);
              setShowSnackBarAlert({
                status: true,
                type: 'error',
                message: response['message']
              });
              policyForm.setErrors({});
              setIsLoading(false);
            }
          })
          .catch(function (err) {
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: err.message
            });
            setLoader(false);
            setIsLoading(false);
          });
      }
    }
  });

  const handleFocus = (fileInput) => {
    setHasBeenClicked(true);
    if (hasBeenClicked && fileInput.value.length === 0) {
      setFlag(true);
      policyForm.setFieldError('policyDocument', 'Policy Document is required');
    }
  };

  const handleFile = (event) => {
    setRetImage(event.target.files[0]);
    policyForm.setFieldValue('policyDocument', event.target.files[0]);
    policyForm.values.policyDocument = event.target.files[0];
    policyForm.setValues(policyForm.values);
    const selectedFiles = event.target.files[0];
    if (!selectedFiles) {
      policyForm.setFieldError('policyDocument', 'Policy Document is required');
    }
  };

  return (
    <>
      <Dialog
        open={true}
        keepMounted
        onClose={() => {
          if (reissue === true) {
            setAddPolicyModal({
              addDetail: null,
              policyId: null,
              status: false
            });
          } else {
            setAddPolicyModal({
              addDetail: null,
              status: false
            });
          }
        }}
        maxWidth={'md'}
        aria-describedby="alert-dialog-slide-description"
      >
        {openWarning?.status && (
          <FileSizeWarningModal
            openWarning={openWarning}
            setOpenWarning={setOpenWarning}
          />
        )}
        <form onSubmit={policyForm.handleSubmit}>
          <DialogTitle>
            <Stack display="flex" direction="row" alignItems="center">
              <Typography
                variant="h4"
                color="black"
                sx={{
                  '&.MuiTypography-root-MuiDialogTitle-root': {
                    margin: '2px !important'
                  }
                }}
              >
                Add Policy Details - {addPolicyModal?.addDetail?.placementId}
              </Typography>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} md={6}>
                <TextField
                  label={
                    <Fragment>
                      Policy Number{' '}
                      <Typography component="span" sx={{ color: 'red' }}>
                        *
                      </Typography>
                    </Fragment>
                  }
                  sx={{ width: '100%' }}
                  size="small"
                  name="policyNumber"
                  type="text"
                  // disabled={
                  //   addPolicyModal?.addDetail?.rfq?.renewalNumber ? true : false
                  // }
                  value={policyForm.values.policyNumber}
                  onChange={policyForm.handleChange}
                  onBlur={policyForm.handleBlur}
                  error={
                    policyForm.touched.policyNumber &&
                    Boolean(policyForm.errors.policyNumber)
                  }
                  helperText={
                    policyForm.touched.policyNumber &&
                    policyForm.errors.policyNumber
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    views={['year', 'month', 'day']}
                    inputFormat="dd-MM-yyyy"
                    label={
                      <Fragment>
                        Policy Issue Date{' '}
                        <Typography component="span" sx={{ color: 'red' }}>
                          *
                        </Typography>
                      </Fragment>
                    }
                    maxDate={new Date()}
                    value={policyForm.values.policyIssueDate}
                    onChange={(newValue: any) => {
                      if (newValue) {
                        policyForm.setValues({
                          ...policyForm.values,
                          policyIssueDate: moment(newValue).format('yyyy-MM-DD')
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        {...params}
                        sx={{ width: '100%' }}
                        onBlur={policyForm.handleBlur}
                        name="policyIssueDate"
                        error={
                          policyForm.touched.policyIssueDate &&
                          Boolean(policyForm.errors.policyIssueDate)
                        }
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                        helperText={
                          policyForm.touched.policyIssueDate &&
                          policyForm.errors.policyIssueDate
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    views={['year', 'month', 'day']}
                    inputFormat="dd-MM-yyyy"
                    label={
                      <Fragment>
                        Policy Document Received Date{' '}
                        <Typography component="span" sx={{ color: 'red' }}>
                          *
                        </Typography>
                      </Fragment>
                    }
                    maxDate={new Date()}
                    value={policyForm.values.policyDocumentReceivedDate}
                    onChange={(newValue: any) => {
                      if (newValue) {
                        policyForm.setValues({
                          ...policyForm.values,
                          policyDocumentReceivedDate:
                            moment(newValue).format('yyyy-MM-DD')
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        {...params}
                        sx={{ width: '100%' }}
                        onBlur={policyForm.handleBlur}
                        name="policyDocumentReceivedDate"
                        error={
                          policyForm.touched.policyDocumentReceivedDate &&
                          Boolean(policyForm.errors.policyDocumentReceivedDate)
                        }
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                        helperText={
                          policyForm.touched.policyDocumentReceivedDate &&
                          policyForm.errors.policyDocumentReceivedDate
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label={<Fragment>Insurance Company</Fragment>}
                  sx={{ width: '100%' }}
                  disabled
                  size="small"
                  name="insuranceCompany"
                  onKeyDown={(e) => {
                    if (['e', 'E', '-', '+'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  InputProps={{
                    inputProps: { min: 0 }
                  }}
                  type="text"
                  value={policyForm.values.insuranceCompany}
                  onChange={policyForm.handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl size="small" fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    style={{ marginTop: 13 }}
                  >
                    Policy Document (PDF){' '}
                    <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <input
                    type="file"
                    name="policyDocument"
                    accept={supportingPolicyDocument}
                    ref={fileRef}
                    // onChange={(event) => {
                    //   setRetImage(event.target.files[0]);
                    //   policyForm.setFieldValue(
                    //     'policyDocument',
                    //     event.target.files[0]
                    //   );
                    // }}
                    onChange={(e) => handleFile(e)}
                    onFocus={(e) => {
                      setTimeout(() => {
                        handleFocus(e.target);
                      }, 250);
                    }}
                    id="standard-basic"
                    // onBlur={policyForm.handleBlur}
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                </FormControl>
                {(policyForm.touched.policyDocument &&
                  policyForm.errors.policyDocument) ||
                  flag ? (
                  <ErrorMessage>
                    {policyForm.errors.policyDocument}
                  </ErrorMessage>
                ) : (
                  ''
                )}
                {/* {(policyForm.touched.policyDocument &&
                  Boolean(policyForm.errors.policyDocument)) ||
                error ? (
                  <Typography sx={{ mt: 3 }} color="error">
                    <b>
                      {(policyForm.touched.policyDocument &&
                        policyForm.errors.policyDocument) ||
                        error}
                    </b>
                  </Typography>
                ) : null} */}
              </Grid>
            </Grid>
            <br />
            <Divider />
            <Box textAlign="start" mt={1}>
              <Card
                sx={{
                  border:
                    policyForm.touched.policyFile &&
                      policyForm.errors.policyFile
                      ? '1px solid #FF1943'
                      : '1px dashed grey',

                }}
              >
                <PolicyAttachments
                  policyForm={policyForm}
                />
              </Card>
            </Box>
            <FormHelperText
              error={
                policyForm.touched.policyFile &&
                Boolean(policyForm.errors.policyFile)
              }
            >
              {policyForm.touched.policyFile && policyForm.errors.policyFile
                ? policyForm.errors.policyFile
                : ''}
            </FormHelperText>

          </DialogContent>
          <DialogActions>
            <LoadingButton
              color="primary"
              loading={isLoading}
              type="submit"
              variant="contained"
            >
              Save
            </LoadingButton>
            <Button
              onClick={() => {
                if (reissue === true) {
                  setAddPolicyModal({
                    addDetail: null,
                    policyId: null,
                    status: false
                  });
                } else {
                  setAddPolicyModal({
                    addDetail: null,
                    status: false
                  });
                }
              }}
              variant="contained"
              color="error"
              disabled={isLoading}
            >
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

AddPolicyView.propTypes = {
  addPolicyModal: PropTypes.func,
  setAddPolicyModal: PropTypes.func,
  setShowSnackBarAlert: PropTypes.func,
  placementSlipDetail: PropTypes.func
};
export default AddPolicyView;
